import React from 'react';
import classnames from 'classnames';

import { Icon, IconType } from '@components/Icon';
import { Tooltip } from '@components/Tooltip';

import style from './SelectButtonItem.module.scss';

export interface SelectButtonItemProps {
    label: string | React.ReactElement<any>;
    dataTest?: string;
    isHighlighted?: boolean;
    disable?: boolean;
    disableHint?: string;
    isSelected?: boolean;
    startIconType?: IconType;
    endIconType?: IconType;
    onItemClick(): void;
    modifiers?: SelectButtonModifiers[];
}

interface Props extends SelectButtonItemProps {
    value?: string;
    toggleIsOpen(): void;
    onItemClick(value?: string): void;
}

export enum SelectButtonModifiers {
    // @ts-ignore
    WithoutPadding = style.withoutTopPadding,
    // @ts-ignore
    DropdownRow = style.dropdownRow,
    // @ts-ignore
    StatusRow = style.statusRow,
}

export function SelectButtonItem({
    isHighlighted,
    disable,
    disableHint,
    label,
    isSelected,
    startIconType,
    endIconType,
    dataTest,
    value,
    onItemClick,
    toggleIsOpen,
    modifiers = [],
}: Props) {
    function handleItemClick() {
        onItemClick(value);
        toggleIsOpen();
    }

    return (
        <div
            className={classnames([
                style.root,
                isHighlighted && style.root_isHighlighted,
                disable && style.root_disabled,
                isSelected && style.root_isSelected,
                ...modifiers,
            ])}
            data-test={dataTest}
            data-testid={dataTest}
            onClick={disable ? undefined : handleItemClick}
        >
            <Tooltip
                title={disableHint ?? ''}
                disable={!disableHint}
            >
                <div className={style.label}>
                    {startIconType && <Icon type={startIconType} />}
                    {label}
                    {endIconType && <Icon type={endIconType} />}
                </div>
            </Tooltip>
        </div>
    );
}
